import React from 'react';
import {connect} from 'react-redux';
import Button from '@material-ui/core/Button';
import {Icon} from '@material-ui/core';
import {I18n} from 'react-redux-i18n';
import {clearReportFile} from '../DVRhealthActions';
import {isMobile} from '../../app/configuration/util';
import IconButton from '@material-ui/core/IconButton';

class DownloadHealthReport extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.reportFile) {
      this.downloadReport(nextProps.reportFile);
      this.props.clearReportFile();
    }
  }

  downloadReport = blob => {
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(blob, 'report.xlsx');
    }
    else {
      var blobURL = window.URL.createObjectURL(blob);
      var tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      tempLink.setAttribute('download', 'report.xlsx');
      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank');
      }
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    }
  }

  render() {
    if (this.props.isMobile) {
      return (
        <IconButton onClick={this.props.handleClick}>
          <Icon color="inherit">file_download</Icon>
        </IconButton>
      )
    }
    return (
      <div>
        <Button color="default" className="btn-terciery" id="dvrHealthReport" onClick={this.props.handleClick}>
           <Icon>file_download</Icon><span>{I18n.t('page.dvrHealth.downloadReport')}</span>
        </Button>
      </div>
    );
  }
}
const mapStateToProps = state => ({...state.i18n.locale, ...state.dvr, isMobile: isMobile(state)});
export default connect(mapStateToProps, {clearReportFile})(DownloadHealthReport);
